import React from 'react'

const HelpSSIcon = (
  <>
    <g clipPath="url(#clip0_2428_3269)">
      <path
        d="M11 21.2077C16.5689 21.2077 21.0833 16.6933 21.0833 11.1244C21.0833 5.55551 16.5689 1.04105 11 1.04105C5.43112 1.04105 0.916656 5.55551 0.916656 11.1244C0.916656 16.6933 5.43112 21.2077 11 21.2077Z"
        fill="transparent"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 17.0827C11.2531 17.0827 11.4583 16.8775 11.4583 16.6244C11.4583 16.3712 11.2531 16.166 11 16.166C10.7469 16.166 10.5417 16.3712 10.5417 16.6244C10.5417 16.8775 10.7469 17.0827 11 17.0827Z"
        fill="transparent"
        stroke="currentColor"
      />
      <path
        d="M11 17.0827C11.2531 17.0827 11.4583 16.8775 11.4583 16.6244C11.4583 16.3712 11.2531 16.166 11 16.166C10.7469 16.166 10.5417 16.3712 10.5417 16.6244C10.5417 16.8775 10.7469 17.0827 11 17.0827Z"
        fill="transparent"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.70831 5.70504C10.6141 4.86216 13.0808 4.96254 13.9237 6.32654C14.7666 7.69054 14.184 9.27591 12.7403 10.4974C11.2965 11.7188 11 12.4535 11 13.416"
        fill="transparent"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2428_3269">
        <rect
          width="22"
          height="22"
          fill="white"
          transform="translate(0 0.12439)"
        />
      </clipPath>
    </defs>
  </>
)

export default HelpSSIcon
